import guantes from './guantes.json';
import { elementToCard, soldadorTable } from './catalog-card.js';
import { initReveal } from './reveal.js';

var render = document.getElementById('render');
render.innerHTML = '<div class="catalog-grid">' + guantes.map(elementToCard).join('') + '</div>';
var cards = render.querySelectorAll('.catalog-card');
document.getElementById('compare-table').innerHTML = soldadorTable(guantes);
var tickerItems = guantes.map(function (glove) { return glove.name + ' · ' + (glove.specs.Costuras || glove.specs.Ajuste); }).concat(['Hechos en Jalostotitlán, Jalisco']);
var tickerList = '<ul>' + tickerItems.map(function (item) { return '<li>' + item + '</li>'; }).join('') + '</ul>';
document.getElementById('ticker').innerHTML = '<div class="ticker-track">' + tickerList + tickerList.replace('<ul>', '<ul aria-hidden="true">') + '</div>';
var filters = document.querySelectorAll('.catalog-filter');
filters.forEach(function (button) {
    button.addEventListener('click', function () {
        filters.forEach(function (filter) {
            var active = filter === button;
            filter.classList.toggle('is-active', active);
            filter.setAttribute('aria-pressed', String(active));
        });
        var count = 0;
        cards.forEach(function (card) {
            card.hidden = button.dataset.filter !== 'todos' && card.dataset.category !== button.dataset.filter;
            if (!card.hidden) count++;
        });
        document.getElementById('catalog-count').textContent = count + (count === 1 ? ' modelo' : ' modelos');
        initReveal(render);
    });
});

var tagline = document.querySelector('.tagline-text');
if (tagline && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    Array.from(tagline.childNodes).forEach(function (node) {
        if (node.nodeType !== Node.TEXT_NODE) return;
        var words = node.textContent.trim().split(/\s+/);
        var fragment = document.createDocumentFragment();
        words.forEach(function (word, index) {
            var span = document.createElement('span');
            span.textContent = word;
            fragment.appendChild(span);
            if (index < words.length - 1) fragment.appendChild(document.createTextNode(' '));
        });
        node.replaceWith(fragment);
    });
    tagline.classList.add('is-animated');
    var words = Array.from(tagline.querySelectorAll('span'));
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            setTimeout(function () { entry.target.classList.add('is-lit'); }, words.indexOf(entry.target) * 100);
            observer.unobserve(entry.target);
        });
    }, { threshold: 1, rootMargin: '0px 0px -20% 0px' });
    words.forEach(function (word) { observer.observe(word); });
}
initReveal();